module.exports = new __parcel__URL__("white_logo_transparent_background.2184994d.png").toString();